import React from 'react'
import { Button, Paper, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface InitialContentProps {
  patientPhone: string
  handleContinueReschedule: () => void
}

export const InitialContent: React.FC<InitialContentProps> = ({ patientPhone, handleContinueReschedule }) => {
  return (
    <S.Container>
      <Typography variant='content2' color='danger' center>
        <strong>Atenção:</strong>{' '}
          tenha certeza de que esta mudança seja alinhada previamente com o paciente. <br />
        <strong>Fale com ele</strong> e combine:
      </Typography>

      <Typography 
        variant='content1'
        color='danger' 
        center 
        weight='bold' 
        customClassName='patientPhoneText'
      >
        {patientPhone}
      </Typography>

      <Paper variant='warning' customClassName='warningPaper'>
        <Typography variant='content2'>
          Ao concluir a mudança, o dia e o horário anteriores são liberados para outros pacientes agendarem (caso esteja cadastrado em sua disponibilidade).
        </Typography>
      </Paper>

      <Button
        variant='contained'
        onClick={handleContinueReschedule}
        customClassName='actionButton'
      >
        Continuar
      </Button>
    </S.Container>
  )
}